import React, { useState } from 'react';
import { NotificationSettingsProps, StaffNotificationSettings } from '../../../types';
import { Toggle } from '../atoms';
import Button from '../../atoms/Button';
import './NotificationSettings.css';

const NotificationSettings: React.FC<NotificationSettingsProps> = ({
  settings,
  onUpdate,
  loading = false
}) => {
  const [notificationSettings, setNotificationSettings] = useState<StaffNotificationSettings>({
    ...settings
  });
  
  const [hasChanges, setHasChanges] = useState(false);
  
  const handleToggleChange = (key: keyof StaffNotificationSettings, checked: boolean) => {
    setNotificationSettings(prev => ({
      ...prev,
      [key]: checked
    }));
    
    setHasChanges(true);
  };
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onUpdate(notificationSettings);
    setHasChanges(false);
  };
  
  return (
    <form className="notification-settings" onSubmit={handleSubmit}>
      <h3>Email Notification Preferences</h3>
      
      <div className="notification-options">
        <Toggle
          id="emailNotifications"
          label="Email Notifications"
          description="Master toggle for all email notifications"
          checked={notificationSettings.emailNotifications}
          onChange={(checked) => handleToggleChange('emailNotifications', checked)}
        />
        
        <div className={`sub-notification-options ${!notificationSettings.emailNotifications ? 'disabled' : ''}`}>
          <Toggle
            id="orderUpdates"
            label="Order Updates"
            description="Receive notifications about new orders and status changes"
            checked={notificationSettings.orderUpdates}
            onChange={(checked) => handleToggleChange('orderUpdates', checked)}
            disabled={!notificationSettings.emailNotifications}
          />
          
          <Toggle
            id="productUpdates"
            label="Product Updates"
            description="Receive notifications about product changes and inventory"
            checked={notificationSettings.productUpdates}
            onChange={(checked) => handleToggleChange('productUpdates', checked)}
            disabled={!notificationSettings.emailNotifications}
          />
          
          <Toggle
            id="customerUpdates"
            label="Customer Updates"
            description="Receive notifications about new customer registrations"
            checked={notificationSettings.customerUpdates}
            onChange={(checked) => handleToggleChange('customerUpdates', checked)}
            disabled={!notificationSettings.emailNotifications}
          />
          
          <Toggle
            id="marketingUpdates"
            label="Marketing Updates"
            description="Receive updates about marketing campaigns and promotions"
            checked={notificationSettings.marketingUpdates}
            onChange={(checked) => handleToggleChange('marketingUpdates', checked)}
            disabled={!notificationSettings.emailNotifications}
          />
        </div>
      </div>
      
      <div className="notification-form-actions">
        <Button
          type="submit"
          disabled={loading || !hasChanges}
        >
          {loading ? 'Saving...' : 'Save Preferences'}
        </Button>
      </div>
    </form>
  );
};

export default NotificationSettings;
